import { Tooltip } from "@chakra-ui/react";

const BADGE_BASE_STYLE =
  "inline-block min-w-[95px] max-w-[120px] px-1.5 py-[2.5px] text-[13px] font-medium text-center whitespace-nowrap overflow-hidden text-ellipsis ";

const StatusBadge = ({ options = [], value, fallbackStyle = "", tooltip }) => {
  const item = options.find((opt) => opt.value === value);

  if (!item) return null;

  const tooltipText = item.label;

  return (
    <Tooltip
      label={tooltipText}
      placement="bottom"
      openDelay={300}
    >
      <span
        className={`${BADGE_BASE_STYLE} ${
          item.optionStyling || fallbackStyle
        }`}
      >
        {item.label}
      </span>
    </Tooltip>
  );
};

export default StatusBadge;